import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function notificationReducer(
  state = initialState.notification,
  action,
) {
  switch (action.type) {
    case types.NOTIFICATION_SUCCESS:
    case types.NOTIFICATION_DANGER:
    case types.NOTIFICATION_WARNING:
    case types.NOTIFICATION_ACCOUNT_NUMBER:
      return Object.assign({}, state, {
        show: true,
        banner: action.banner,
        error: null,
      });
    case types.NOTIFICATION_MANUAL_TRANSACTION:
      return Object.assign({}, state, {
        transShow: true,
        banner: action.banner,
        error: null,
      });
    case types.NOTIFICATION_TAKE_ACTION_INTERNAL_CASE:
      return Object.assign({}, state, {
        internalCaseShow: true,
        banner: action.banner,
        error: null,
      });
    case types.NOTIFICATION_DISMISS:
      return Object.assign({}, state, {
        show: false,
        transShow: false,
        internalCaseShow:false,
      });
    default:
      return state;
  }
}
